import {CourseModule} from "../../models/course-module";
import {CourseVideo} from "../../models/course-video";
import {ChallengeInApp} from "../../models/challenge-in-app";
import {ChallengeUser} from "../../models/challenge-user";

export class UserStats {
  date: string;
  steps: number;
  extraActivitySum: number;
  activitySum: number;
  mood: number;
  moodFeedback: string;
  activityDaysCount: number;
  groups: {};

  progress: UserProgress;
  constructor(data: any = null) {
    for (var k in data) {
      this[k] = data[k];
    }
  }

  getActivityMinutes() {
    return this.activitySum+this.extraActivitySum;
  }

  toJSON() {
    return {
      steps: this.steps?parseInt(this.steps.toString()):0,
      mood: this.mood?parseInt(this.mood.toString()):0,
      moodFeedback: this.moodFeedback,
    }
  }
}

export class UserProgress {
  date: string;
  status: number;
  taskDone: boolean;
  videoShown: boolean;
  videoId: string;
  video: CourseVideo;
  stats: UserStats;
  messageShown: boolean;
  stateRefreshRequired: boolean;
  stateNewModuleUnlocked: boolean;
  stateNewModuleAvailableInDays: number;
  stateModuleClosed: boolean;
  locked: boolean;

  constructor(data: any = null) {
    for (var k in data) {
      this[k] = data[k];
    }

    if(this.date) {
      this.date = this.date.substr(0, 10);
    }
  }

  public isFinished() {
    return this.taskDone && this.videoShown;
  }

  public toJSON() {
    return {date: this.date, taskDone: this.taskDone, videoShown: this.videoShown, messageShown: this.messageShown};
  }

  triggerVideoStatusUpdate() {
    if(this.isFinished() && this.video && this.stats) {
      if(this.video._userStatus == 2) {
        this.video.module._userClosed = 1;
        this.video.module.videos.map(row => {
          if(row._userStatus == 3) {
            this.video.module._userClosed++;
          }
        })
      }
      this.video._userStatus = 3;
    } else if(this.video) {
      this.video._userStatus = 2;
    }
  }
}

export class UserFinishedVideo {
  date: string;
  id: string;
}

export class UserStateDto {
  finishedVideos: UserFinishedVideo[];
  courseModules: CourseModule[];
  currentProgress: UserProgress;
  recentStats: UserStats[];
  tags: any;
  additionalVideos: Array<CourseVideo>;
  challengesInApp: Array<ChallengeInApp>;
  challengesUser: Array<ChallengeUser>;
}



// WEBPACK FOOTER //
// ./src/providers/api-course-data/user-state-dto.ts